export default __webpack_public_path__ + "static/media/facebookFill.7f985775.svg";